import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'delivery'
})
export class DeliveryPipe implements PipeTransform {

  delivery:string= "";

  transform(value: boolean): unknown {
    if(value){
      this.delivery = 'Envío a Domicilio'
    }
    else{
      this.delivery= 'Retiro en Local'
    }
    return this.delivery;
  }

}
